import { wishListSharingStatusStyles as styles } from "@insite/content-library/Components/WishListSharingStatus";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.statusText = {
    ...styles.statusText,
    css: css`
        display: flex;
        align-items: center;
    `,
    mergeCss: true,
};
